import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import { useCommonStore } from '@/js/lib/store/common';
import { useUserStore } from '@/js/lib/store/user';
import { useShopStore } from '@/js/lib/store/shop';
import { useNotificationStore } from '@/js/lib/store/notification';
import { useTodoStore } from '@/js/lib/store/todo';
import { useMessageStore } from '@/js/lib/store/message';
import { useTimelineStore } from '@/js/lib/store/timeline';
import { credentials } from '@/js/lib/api/user';
import { dynamicImageUrl } from '@/js/lib/helper/url';
import { omitWithCap } from '@/js/lib/helper/number';
import ShopStatusVacation from '@/js/components/organisms/ShopStatusVacation.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderAccount',
  setup(__props) {

const commonStore = useCommonStore();
const userStore = useUserStore();
const shopStore = useShopStore();
const notificationStore = useNotificationStore();
const todoStore = useTodoStore();
const messageStore = useMessageStore();
const timelineStore = useTimelineStore();
const isPreSeller = userStore.hasCredential(credentials.preSeller);
const isPromoter = userStore.hasCredential(credentials.promoter);
const isSeller = userStore.hasCredential(credentials.seller);

onMounted(() => {
  if (userStore.isAuthenticated) {
    if (isPreSeller) {
      notificationStore.checkUpdated();
      todoStore.loadTodos();
    }
    messageStore.checkUnreadCount();
    timelineStore.checkItemUpdated();
    timelineStore.checkEventUpdated();
  }
});

return { __sfc: true,commonStore, userStore, shopStore, notificationStore, todoStore, messageStore, timelineStore, isPreSeller, isPromoter, isSeller, dynamicImageUrl, omitWithCap, ShopStatusVacation }
}

})